import React from 'react'

import {
    PopupTitle,
    PopupContainer,
    PopupDescription,
    PopupButtonsContainer,
    PopupButton,
    TitleContainer
} from "../CandidateView.styles";

interface ShowContactsActionProps {
    onConfirm: () => void
    onCancel: () => void
}

const ShowContactsAction = ({
    onConfirm,
    onCancel,
}: ShowContactsActionProps) => {
    return (
        <PopupContainer>
            <TitleContainer><PopupTitle>Allow candidate to see Office Contact Info?</PopupTitle></TitleContainer>
            <PopupDescription>
                Do you want to allow the candidate to see Office Contact Info?
            </PopupDescription>
            <PopupButtonsContainer>
                <PopupButton
                    variant="outlined"
                    onClick={onCancel}
                    color="primary"
                    size="large"
                    id="cancel-button"
                    className="bigButtonInNewStyle"
                >
                    No
                </PopupButton>
                <PopupButton
                    variant="contained"
                    onClick={onConfirm}
                    color="primary"
                    size="large"
                    id="confirm-button"
                    className="bigButtonInNewStyle"
                >
                    Yes
                </PopupButton>
            </PopupButtonsContainer>
        </PopupContainer>
    )
}

export default ShowContactsAction;
